module.exports = "<section class=\"container-panel box\"><checkbox class=styled_checkbox ng-model=purchaseCarbon ng-change=onCarbonChange() ng-disabled=isDisabled></checkbox>&nbsp;<span><l10n>I agree to purchase</l10n>&nbsp; <span class=count ng-bind-html=\"price | currencyByCode: tripData.Prices.CarbonPrice.CurrencyCode\"></span>&nbsp;<l10n>of Carbon offset based on</l10n>&nbsp; <span ng-bind-html=\"pricePerTone | currencyByCode: tripData.Prices.CarbonPrice.CurrencyCode\"></span>/<l10n>tonne of CO2e</l10n></span></section>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/templates/partials/checkout/checkout.carbon.tmpl.html
// module id = 3305
// module chunks = 0